import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const ADD_MEDITATION = "create";
const DELETE_MEDITATION = "delete";
const GET_MEDITATION = "get";
const EDIT_MEDITATION = "edit";

export default {
  createMeditation(payload) {
    return Repository.post(transformRoute(ADD_MEDITATION), payload);
  },
  deleteMeditation(payload) {
    return Repository.post(transformRoute(DELETE_MEDITATION), payload);
  },
  getMeditation(payload) {
    return Repository.post(transformRoute(GET_MEDITATION), payload);
  },
  editMeditation(payload) {
    return Repository.post(transformRoute(EDIT_MEDITATION), payload);
  },
};

const transformRoute = (route) => {
  return `appservices/meditation/${route}`;
};
